/* eslint-disable no-undef */
/* eslint-disable no-console */
import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";
import { IMAGE_MAP, parseExclusiveServices } from "../../../utils/parsers/parse-exclusive-services";
import { parseBannersFromRetailPanel } from "../../../utils/helpers/parse-banners-from-retail-panel";

export const INITIAL_STATE = {
    pageType: "home",
    state: null,
    rto: null,
    stateUrl: null,
    isLoading: false,
    isFetched: false,
    cms: {
        h1: null,
        h2: null,
        description: null,
        meta: {
            title: null,
            description: null
        }
    },
    list: [],
    isSSR: false,
    noContent: false,
    stateList: null,
    blogList: [],
    bestCategory: null,
    usedCar: null,
    exclusiveServices: null,
    vehicleSellingDetail: null,
    rtoList: null,
    popularCityDetails: [],
    vasDetails: {},
    questions: [],
    bannerList: []
};

export const fetchRTODetails = (state = INITIAL_STATE) => {
    return { ...state, isLoading: true, isFetched: false };
};

export const fetchRTODetailsSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        isLoading: false,
        isFetched: true,
        ...data,
        exclusiveServices: parseExclusiveServices(data.exclusiveServices, IMAGE_MAP.DESKTOP)
    };
};

export const fetchRTODetailsFailure = (state = INITIAL_STATE) => {
    return { ...state, isLoading: false, isFetched: true };
};

export const updateSSRStatus = (state = INITIAL_STATE, { isSSR }) => {
    return { ...state, isSSR };
};

export const setPopularCityDetails = (state = INITIAL_STATE, { popularCityDetails }) => {
    return { ...state, popularCityDetails };
};

export const setVasDetails = (state = INITIAL_STATE, { vasDetails }) => {
    return { ...state, vasDetails: { ...state.vasDetails, ...vasDetails } };
};

export const setQuestions = (state = INITIAL_STATE, { questions }) => {
    return { ...state, questions };
};

export const setBanners = (state = INITIAL_STATE, { bannerList }) => {
    return { ...state, bannerList: parseBannersFromRetailPanel(bannerList, true) || []};
};

export const HANDLERS = {
    [Types.FETCH_RTO_DETAILS]: fetchRTODetails,
    [Types.FETCH_RTO_DETAILS_SUCCESS]: fetchRTODetailsSuccess,
    [Types.FETCH_RTO_DETAILS_FAILURE]: fetchRTODetailsFailure,
    [Types.UPDATE_SSR_STATUS]: updateSSRStatus,
    [Types.SET_POPULAR_CITY_DETAILS]: setPopularCityDetails,
    [Types.SET_VAS_DETAILS]: setVasDetails,
    [Types.SET_QUESTIONS]: setQuestions,
    [Types.SET_BANNER_LIST]: setBanners
};

export default createReducer(INITIAL_STATE, HANDLERS);
